// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip-module__root___L7KjC","arrow--hide":"Tooltip-module__arrow--hide___ZOULi","arrow":"Tooltip-module__arrow___6vBsE"};